import { leftContentType } from '../../../nbr-filter-new-style/sections/left-content/left-content';
import { MetricsOptions } from '../../../types';
import {
  NeedsBasedRecOption,
  needsBasedRecAtom,
} from '../../needs-based-rec-selection.atom';
import {
  Container,
  Disclaimer,
  ProductLink,
  Subtitle,
} from './left-content.style';
import { useTrackLDMetric } from '@exploration/feature-management';
import { NextPageWithLayout } from '@exploration/shared-types';
import { MDSText } from '@thrivent/midwest-web';
import { useAtom } from 'jotai';

export interface NeedsBasedRecLeftContentProps {
  leftContentData?: {
    [NeedsBasedRecOption.PERSONALIZED_FINANCIAL_PLANNING]: leftContentType;
    [NeedsBasedRecOption.BUDGETING_AND_SAVING]: leftContentType;
    [NeedsBasedRecOption.DAY_TO_DAY_SPENDING]: leftContentType;
    [NeedsBasedRecOption.RETIREMENT_PLANNING]: leftContentType;
    [NeedsBasedRecOption.INVESTING]: leftContentType;
    [NeedsBasedRecOption.GENEROSITY_AND_GIVING]: leftContentType;
    [NeedsBasedRecOption.GETTING_INSURED]: leftContentType;
  };
}

// --------------------------------------------------------------------------

export const NeedsBasedRecLeftContent: NextPageWithLayout<
  NeedsBasedRecLeftContentProps
> = ({ leftContentData }) => {
  const [needsBasedData] = useAtom(needsBasedRecAtom);
  const { trackMetric } = useTrackLDMetric();

  if (!needsBasedData.selectedOption || !leftContentData) {
    return null;
  }

  const selectedContent = leftContentData[needsBasedData.selectedOption];

  return (
    <Container>
      <MDSText.HeroSm as="h2">{selectedContent.title}</MDSText.HeroSm>
      <Subtitle as="h3">{selectedContent.subtitle}</Subtitle>
      <MDSText.BodyRegDefault as={'p'}>
        {selectedContent.description}
      </MDSText.BodyRegDefault>
      <ProductLink
        href={selectedContent.href}
        target="_blank"
        data-analytics-name={`${selectedContent.analyticsName}-link`}
        onClick={() => trackMetric(MetricsOptions.nbrClickOnLinks)}
      >
        {selectedContent.linkText}
      </ProductLink>
      {!!selectedContent.disclaimer && (
        <Disclaimer as={'p'}>{selectedContent.disclaimer}</Disclaimer>
      )}
    </Container>
  );
};

// -------------------------------------------------------------------------

export default NeedsBasedRecLeftContent;
